import React, { Component } from 'react'
import { Link } from 'react-router'

export default class Header extends Component {
  render() {

    return (
      <div className="navbar nav_title" style={{ border: "0" }}>
        <Link to="/" className="site_title"><img src="/images/logo-white.png" /></Link>
      </div>
    )

    /*
    return (
      <div className="header">
        <img src="images/logo.png" /> Capacitor&trade;
      </div>
    )
    */
  }
}



// WEBPACK FOOTER //
// ./src/components/header.js